import { OrgUserRoleTable } from "../components/OrgUserRole/OrgUserRoleTable";
import { OrgView } from "../components/Org";

export function OrgUserRolesScreen() {
  return (
    <OrgView title="Members">
      {({ category, id }) => <OrgUserRoleTable category={category} id={id} />}
    </OrgView>
  );
}
